//-------------------------------------------------------------
//  Vue Custom Filters
//-------------------------------------------------------------

// Use: <element>{{ value | currency }}</element>
Vue.filter('currency', function (value) {
    let currency = window.geoip.currencySymbol;

    if (typeof value === 'string') {
        value = parseFloat(value.replace(/[^$£€]/, ''));
    }

    if (!value) return currency + 0.00;

    value = (value / 100).toFixed(2);

    if (value.charAt(0) === '-') {
        value = value.substring(1, value.length);
        return '-' + currency + value
    }

    return  currency + value;
});

// Use: <element>{{ string | truncate(100) }}</element>
Vue.filter('truncate', function (string, value) {

    if (string.length > value) {
        return string.substring(0,value) + "...";
    } else {
        return string;
    }
});

// Use: <element>{{ string | kebab }}</element>
Vue.filter('kebab', function (value) {
    let string = value;

    if (string.length) {
        const toKebabCase = str =>
            str &&
            str
                .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
                .map(x => x.toLowerCase())
                .join('-');

        string = toKebabCase(string);
    }

    return string;
});

import { formatDate, formatDateTime, formatTimeDate, formatLocalTime } from './dayjs';

Vue.filter('formatDate', function (value) {
    return formatDate(value);
});

Vue.filter('formatDateTime', function (value) {
    return formatDateTime(value);
});

Vue.filter('formatTimeDate', function (value) {
    return formatTimeDate(value);
});

Vue.filter('formatLocalTime', function (value) {
    return formatLocalTime(value);
});
